import { useAuth } from "../../auth/hooks";
import { AxiosError } from "axios";
import { errorCodes } from "../types/errorCode";

export default function useErrorHandler() {
  const {logOutUser} = useAuth();
  const handleErrorAxios = (error?: AxiosError) => {
    const errorData = error?.response?.data as any;
    const messageError =
      errorData?.message ||
      errorData?.error ||
      errorData?.errors ||
      errorData?.detail ||
      errorData?.detail ||
      errorData?.error ||
      errorData?.message;

    if (messageError ){
        if (messageError.includes(errorCodes.USER_NOT_LOGGED_IN)){
          logOutUser()
        }
    }
  };
  return {
    handleErrorAxios,
  };
}
